import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';
import { selectSpinnerStatus } from '@/state/general/generalSelectors';
import Backdrop from '@mui/material/Backdrop';
import AnimatedLogo from '@/components/AnimatedLogo';

const Spinner = ({ color }: { color?: any }) => {
    const spinner = useSelector((state: RootState) => selectSpinnerStatus(state));

    if (!spinner) return null;

    return (
        <Backdrop
            sx={{
                color: (theme) => color || theme.palette.primary.main,
                zIndex: (theme) => theme.zIndex.drawer + 1000,
            }}
            open={spinner}
            onClick={() => {}}
        >
            <AnimatedLogo />
        </Backdrop>
    );
};

export default Spinner;
